import { render, staticRenderFns } from "./NavLogo.vue?vue&type=template&id=78e5ca5c&"
import script from "./NavLogo.vue?vue&type=script&lang=ts&"
export * from "./NavLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteLogo: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/SiteLogo.vue').default,SiteName: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/SiteName.vue').default})
